import ImgPc from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_pc.jpg";
import ImgSp from "$/images/campaign/freeDeliveryfee/bnr_freedelivery_sp.jpg";

import { ProductLargeImage } from "../../product/ProductLargeImage";

export function FreeShippingCampaign(): React.ReactNode {
  return (
    <ProductLargeImage
      spImage={{
        src: ImgSp,
        alt: "新生活応援セール 送料無料",
      }}
      pcImage={{
        src: ImgPc,
        alt: "コース初回・再開者限定",
      }}
      full="true"
    />
  );
}
